module.exports = __webpack_public_path__ + "static/media/hourglass.32959fb5.svg";